import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import I18n from 'I18n';
import { Record as ImmutableRecord, List, Range } from 'immutable';
var defaults = {
  start: 0,
  end: Infinity
};

function convertToMinutes(timestamp) {
  return Math.floor(timestamp / 60000);
}

function convertToMilliseconds(timestampMinutes) {
  return timestampMinutes * 60000;
}

var TimeRange = /*#__PURE__*/function (_ImmutableRecord) {
  _inherits(TimeRange, _ImmutableRecord);

  function TimeRange() {
    _classCallCheck(this, TimeRange);

    return _possibleConstructorReturn(this, _getPrototypeOf(TimeRange).apply(this, arguments));
  }

  _createClass(TimeRange, [{
    key: "toBlocks",
    value: function toBlocks(duration) {
      var _this = this;

      return Range(0, Math.floor(this.duration() / duration)).map(function (i) {
        return TimeRange.from({
          start: _this.start + i * duration,
          end: _this.start + (i + 1) * duration
        });
      }).toList();
    }
  }, {
    key: "toMinutes",
    value: function toMinutes() {
      if (!this.isInMinutes()) {
        return TimeRange.from({
          start: convertToMinutes(this.start),
          end: convertToMinutes(this.end)
        });
      }

      return this;
    }
  }, {
    key: "toMilliseconds",
    value: function toMilliseconds() {
      if (!this.isInMilliseconds()) {
        return TimeRange.from({
          start: convertToMilliseconds(this.start),
          end: convertToMilliseconds(this.end)
        });
      }

      return this;
    }
  }, {
    key: "isInMilliseconds",
    value: function isInMilliseconds() {
      var FIFTEEN_MINUTE_DURATION = I18n.moment.duration({
        minutes: 15
      }).asMilliseconds();
      return Math.floor(this.end / FIFTEEN_MINUTE_DURATION) >= 1;
    }
  }, {
    key: "isInMinutes",
    value: function isInMinutes() {
      var DAY_DURATION_MINUTES = I18n.moment.duration({
        hours: 24
      }).asMinutes();
      return Math.floor(this.end / DAY_DURATION_MINUTES) <= 1;
    }
  }, {
    key: "isValidTimeRange",
    value: function isValidTimeRange() {
      return List([typeof this.start, typeof this.end]).every(function (t) {
        return t === 'number';
      });
    }
  }, {
    key: "duration",
    value: function duration() {
      return this.end - this.start;
    }
  }, {
    key: "contain",
    value: function contain(time) {
      return Math.max(Math.min(time, this.end - 1), this.start);
    }
  }, {
    key: "timeToOffsetFloat",
    value: function timeToOffsetFloat(time) {
      return (time - this.start) / this.duration();
    }
  }, {
    key: "isEqual",
    value: function isEqual(dtr) {
      return this.start === dtr.start && this.end === dtr.end;
    }
  }, {
    key: "hasIntersection",
    value: function hasIntersection(dtr) {
      return this.start < dtr.end && this.end > dtr.start;
    }
  }, {
    key: "contains",
    value: function contains(time) {
      return this.start <= time && this.end > time;
    }
  }, {
    key: "pushBack",
    value: function pushBack(duration) {
      return TimeRange.from({
        start: this.start - duration,
        end: this.end - duration
      });
    }
  }, {
    key: "subtractStart",
    value: function subtractStart(duration) {
      return TimeRange.from({
        start: this.start - duration,
        end: this.end
      });
    }
  }, {
    key: "subtractEnd",
    value: function subtractEnd(duration) {
      return TimeRange.from({
        start: this.start,
        end: this.end - duration
      });
    }
  }, {
    key: "union",
    value: function union(dtr) {
      if (!this.hasIntersection(dtr)) return List([this, dtr]);
      return List([TimeRange.from({
        start: Math.min(this.start, dtr.start),
        end: Math.max(this.end, dtr.end)
      })]);
    }
  }, {
    key: "intersect",
    value: function intersect(dtr) {
      if (!this.hasIntersection(dtr)) return null;
      return TimeRange.from({
        start: Math.max(this.start, dtr.start),
        end: Math.min(this.end, dtr.end)
      });
    }
  }, {
    key: "clipEnd",
    value: function clipEnd(edge) {
      if (edge < this.start) return null;
      return TimeRange.from({
        start: Math.min(edge, this.start),
        end: Math.min(edge, this.end)
      });
    }
  }, {
    key: "clipStart",
    value: function clipStart(edge) {
      if (edge > this.end) return null;
      return TimeRange.from({
        start: Math.max(edge, this.start),
        end: Math.max(edge, this.end)
      });
    }
  }], [{
    key: "from",
    value: function from(json) {
      return new TimeRange(json);
    }
  }]);

  return TimeRange;
}(ImmutableRecord(defaults));

export { TimeRange as default };